import circle from '../assets/circle.png'
import plus from '../assets/add.png'
import { motion } from 'framer-motion';

const Contact = () => {
    

    return (
        <div className="relative flex items-center flex-wrap justify-between bg-gray-950 py-32 px-8 tab:px-4">

            <motion.h2 
                className="text-white text-4xl font-bold mb-10"
                initial= 'hidden'
                whileInView="visible"
                viewport={{ once: true, }}
                variants={{
                    hidden: { opacity: 0, y: 75 },
                    visible: { opacity: 1, y: 0 }
                }}
                transition={{ duration: 0.5, delay: 0.5, type: 'spring',  stiffness: 150 }}
            >
                Contact us for the service you want to use
            </motion.h2>

            <motion.button 
                className='bg-blue text-lg text-white font-semibold py-1.5 px-7 rounded-sm cursor-pointer'
                initial= 'hidden'
                whileInView="visible"
                viewport={{ once: true, }}
                variants={{
                    hidden: { opacity: 0, x: 75 },
                    visible: { opacity: 1, x: 0 }
                }}
                transition={{ duration: 0.5, delay: 0.5, type: 'spring',  stiffness: 200 }}
            >
                Contact us
            </motion.button>

            <img 
                src={plus}
                alt="Hero Img" 
                className='absolute top-6 right-6 w-10'
            />

            <img 
                src={circle}
                alt="Hero Img" 
                className='absolute bottom-5 left-6 w-10'
            />
        </div>
    );
}
 
export default Contact;